import { AgChartTheme } from "ag-charts-community";
import colors from "theme/colors";

export const MaybernAgChartTheme: AgChartTheme = {
  overrides: {
    common: {
      axes: {
        category: {
          title: {
            fontSize: 10,
            color: colors.gray[600],
          },
          label: {
            fontSize: 8,
            color: colors.gray[400],
          },
        },
        number: {
          title: {
            fontSize: 10,
            color: colors.gray[600],
          },
          label: {
            fontSize: 8,
            color: colors.gray[400],
          },
          gridLine: {
            style: [
              {
                stroke: colors.gray[100],
              },
            ],
          },
          tick: {
            color: colors.gray[100],
          },
        },
        time: {
          title: {
            fontSize: 10,
            color: colors.gray[600],
          },
          label: {
            color: colors.gray[400],
            fontSize: 8,
          },
          line: {
            enabled: false,
          },
          gridLine: {
            style: [
              {
                stroke: colors.gray[100],
              },
            ],
          },
          tick: {
            color: colors.gray[100],
          },
        },
        "ordinal-time": {
          title: {
            fontSize: 10,
            color: colors.gray[600],
          },
          label: {
            color: colors.gray[400],
            fontSize: 8,
          },
          line: {
            enabled: false,
          },
          gridLine: {
            style: [
              {
                stroke: colors.gray[100],
              },
            ],
          },
          tick: {
            color: colors.gray[100],
          },
        },
      },
      legend: {
        position: "right",
        item: {
          toggleSeriesVisible: false,
          marker: {
            shape: "square",
            size: 8,
          },
          label: {
            color: colors.gray[500],
            fontSize: 11,
          },
        },
      },
    },
    line: {
      series: {
        marker: {
          size: 3,
        },
      },
    },
  },
};
